import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

const MUSTER_MAX_ANZAHL = 20;
/** Backend-@Size an KiMandantEinstellungenDTO.eigeneMuster. */
const MUSTER_MAX_LAENGE = 200;
/** Java kennt das Flag am Anfang, JavaScript nicht; das Backend lässt es ganz vorne zu. */
const FLAG_OHNE_GROSSKLEINSCHREIBUNG = '(?i)';

/**
 * Nur die Syntax: Was das Backend darüber hinaus ablehnt (Gruppen, Alternativen …), meldet es beim Laden als
 * Hinweis und beim Speichern mit KI_MUSTER_UNGUELTIG samt Grund.
 */
export function musterFehler(muster: string): string | null {
  const ausdruck = muster.startsWith(FLAG_OHNE_GROSSKLEINSCHREIBUNG)
    ? muster.slice(FLAG_OHNE_GROSSKLEINSCHREIBUNG.length)
    : muster;
  try {
    new RegExp(ausdruck);
    return null;
  } catch {
    return 'settings.ki.maskierung.fehler.ungueltig';
  }
}

/** Maskierung vor dem Senden (page-ki-einstellungen.jsx:96-110). */
@Component({
  selector: 'app-ki-maskierung',
  standalone: true,
  imports: [MatButton, MatIcon, TranslatePipe],
  templateUrl: './ki-maskierung.component.html',
  styleUrl: './ki-maskierung.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiMaskierungComponent {
  readonly muster = input.required<string[]>();
  /** Gründe des Backends je Musterwert: gespeicherte ungültige Muster und die Ablehnung beim Speichern. */
  readonly meldungen = input<ReadonlyMap<string, string>>(new Map());
  readonly musterGeaendert = output<string[]>();

  readonly maxLaenge = MUSTER_MAX_LAENGE;
  readonly neu = signal('');
  /** Erst nach einem Versuch prüfen, damit beim Tippen eines halben Ausdrucks kein Fehler aufblinkt. */
  private readonly versucht = signal(false);
  readonly voll = computed(() => this.muster().length >= MUSTER_MAX_ANZAHL);
  readonly neuFehler = computed(() => {
    const muster = this.neu().trim();
    return this.versucht() && muster ? musterFehler(muster) : null;
  });
  /** Sperrt das Speichern der Seite, solange der abgelehnte Ausdruck im Feld steht. */
  readonly eingabeUngueltig = computed(() => !!this.neuFehler());
  /** Getippt, aber noch nicht hinzugefügt. */
  readonly hatEntwurf = computed(() => !!this.neu().trim());

  zuruecksetzen(): void {
    this.neu.set('');
    this.versucht.set(false);
  }

  onNeu(event: Event): void {
    this.neu.set((event.target as HTMLInputElement).value);
  }

  onHinzufuegen(): void {
    const muster = this.neu().trim();
    if (!muster || this.voll()) return;
    this.versucht.set(true);
    if (musterFehler(muster)) return;
    this.musterGeaendert.emit([...this.muster(), muster]);
    this.neu.set('');
    this.versucht.set(false);
  }

  onEntfernen(index: number): void {
    this.musterGeaendert.emit(this.muster().filter((_, i) => i !== index));
  }
}
